module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("4Od2P"))).then(() => parcelRequire('ljzG9'));